import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types
export interface Profile {
  id: string;
  username?: string;
  display_name?: string;
  phone_number?: string;
  whatsapp_opt_in?: boolean;
  notification_preferences?: Record<string, boolean>;
  created_at: string;
}

export interface Wishlist {
  id: string;
  user_id: string;
  title: string;
  description?: string;
  is_public: boolean;
  created_at: string;
  items?: WishlistItem[];
}

export interface WishlistItem {
  id: string;
  wishlist_id: string;
  title: string;
  price?: number;
  image_url?: string;
  original_url: string;
  affiliate_url?: string;
  affiliate_clicks: number;
  is_purchased: boolean;
  created_at: string;
}

